import {
  Box,
  CircularProgress,
  Container,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { UserTable } from "../../component/common/customTable/UserTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get_users_list_by_role } from "../../services/DashboardUsers";
import { themeOrange, themeBlue } from "../../utils/colorTheme";
import { asyncStatus } from "../../utils/asyncStatus";
import { IoAdd, IoSearch } from "react-icons/io5";
import { FiUsers } from "react-icons/fi";

const DashboardUsers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const { get_users_list_by_role_status, get_users_list_by_role_data } =
    useSelector((state) => state.dashboard_users);

  useEffect(() => {
    dispatch(get_users_list_by_role(3));
  }, []);

  if (get_users_list_by_role_status === asyncStatus.LOADING) {
    return (
      <Stack alignItems="center" justifyContent="center" height="60vh">
        <CircularProgress size={30} sx={{ color: themeOrange }} />
      </Stack>
    );
  }

  return (
    <Stack sx={{ bgcolor: "#F8F9FA", minHeight: "100vh" }}>
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 3, py: 2.5 }}
      >
        <Stack>
          <Typography sx={{ fontSize: "24px", fontWeight: 700, color: themeBlue }}>
            Users
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#999", mt: 0.3 }}>
            Manage all registered customers
          </Typography>
        </Stack>
        <Box
          onClick={() => navigate("/users/add-users")}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            background: "linear-gradient(135deg, #F15A24 0%, #C53F10 100%)",
            color: "#fff",
            px: 2.5,
            py: 1.2,
            borderRadius: "10px",
            cursor: "pointer",
            transition: "all 0.2s",
            "&:hover": { transform: "translateY(-1px)", boxShadow: "0 4px 12px rgba(241,90,36,0.35)" },
          }}
        >
          <IoAdd size={18} />
          <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Add User</Typography>
        </Box>
      </Stack>

      <Container sx={{ maxWidth: { xl: "xl", lg: "lg", md: "md", sm: "sm", xs: "xs" } }}>
        {/* Search */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <TextField
            size="small"
            placeholder="Search users..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IoSearch color="#999" />
                </InputAdornment>
              ),
            }}
            sx={{
              width: "320px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                bgcolor: "#fff",
                "&.Mui-focused fieldset": { borderColor: themeOrange },
                "&:hover fieldset": { borderColor: themeOrange },
              },
            }}
          />
          <Typography sx={{ fontSize: "13px", color: "#999" }}>
            {get_users_list_by_role_data?.length || 0} users total
          </Typography>
        </Stack>

        {/* Table */}
        <Stack
          sx={{
            bgcolor: "#fff",
            borderRadius: "14px",
            boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
            overflow: "hidden",
            mb: 4,
          }}
        >
          <UserTable searchQuery={searchQuery} />
        </Stack>
      </Container>
    </Stack>
  );
};

export default DashboardUsers;
